import React from "react";
import "./GramsevakPage.css";

const GramsevakPage = () => {
  const officer = {
    name: " शौ. देवयानी ठोंबरे",
    designation: "ग्रामपंचायत अधिकारी (ग्रामसेवक)",
    posting: "ग्रामपंचायत ठोंबरा",
    taluka: "उमरेड",
    district: "नागपूर",
    pincode: "---",
    contact: "9834506167",
    email: "thombragp4@gmail.com",
    photo: `${process.env.PUBLIC_URL}/images/sachiv.jpeg`,
  };

  return (
    <div className="gs-container">
      {/* ===== Top Header ===== */}
      <div className="gs-header">
        <div className="gs-title">
          ग्रामपंचायत ठोंबरा  
          <span>पंचायत समिती उमरेड | जिल्हा नागपूर</span>
        </div>
      </div>

      {/* ===== Officer Card ===== */}
      <div className="gs-officer-card">
        <img src={officer.photo} alt="Gramsevak" />
        <div>
          <h2>{officer.name}</h2>
          <p className="designation">{officer.designation}</p>
          <p className="posting">
            कार्यरत ग्रामपंचायत : <b>{officer.posting}</b>
          </p>
          <p className="contact">📞 {officer.contact}</p>
        </div>
      </div>

      {/* ===== Official Info ===== */}
      <section className="gs-section">
        <h3>अधिकृत माहिती</h3>
        <div className="info-grid">
          <Info label="तालुका" value={officer.taluka} />
          <Info label="जिल्हा" value={officer.district} />
          <Info label="पिनकोड" value={officer.pincode} />
          <Info label="ई-मेल" value={officer.email} />
        </div>
      </section>

      {/* ===== Duties ===== */}
      <section className="gs-section">
        <h3>मुख्य कर्तव्ये व जबाबदाऱ्या</h3>
        <ul className="gs-list">
          <li>ग्रामपंचायत प्रशासनाची अंमलबजावणी</li>
          <li>ग्रामसभा आयोजन व कार्यवृत्त तयार करणे</li>
          <li>शासकीय योजना राबविणे (मनरेगा, PMAY, SBM)</li>
          <li>जन्म–मृत्यू व इतर नोंदणी</li>
          <li>ग्रामपंचायत अभिलेख व्यवस्थापन</li>
        </ul>
      </section>

      {/* ===== Success Stories Style Boxes ===== */}
      <section className="gs-section">
        <h3>आमच्या कामगिरीची झलक</h3>
        <div className="success-grid">
          <div className="success-box water">
            💧 <b>पाणीपुरवठा सुधारणा</b>
            <p>नवीन नळ योजना व टाकी दुरुस्ती.</p>
          </div>
          <div className="success-box green">
            🌱 <b>स्वच्छता अभियान</b>
            <p>SBM अंतर्गत गाव स्वच्छता.</p>
          </div>
          <div className="success-box clock">
            ⏱ <b>वेळेवर सेवा</b>
            <p>दाखले व नोंदी वेळेत.</p>
          </div>
        </div>
      </section>

      {/* ===== Footer ===== */}
      <div className="gs-footer">
        सदर माहिती <b>महाराष्ट्र नागरी सेवा नियम १९८१</b> नुसार तयार करण्यात आली आहे.
        <br />
        © जिल्हा परिषद नागपूर | ग्रामविकास विभाग
      </div>
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="info-row">
    <span>{label}</span>
    <b>{value}</b>
  </div>
);

export default GramsevakPage;
